import { useState } from "react";

export type FloatingPosition = { top: number; left: number };

export const SESSION_MENU_WIDTH = 198;
export const SESSION_MENU_HEIGHT = 160;
export const PROJECT_SUBMENU_WIDTH = 220;
export const PROJECT_SUBMENU_HEIGHT = 260;

const FLOATING_GAP = 8;
const FLOATING_MARGIN = 8;

function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), Math.max(min, max));
}

function positionFloatingLayer(triggerRect: DOMRect, width: number, height: number): FloatingPosition {
  const rightSideLeft = triggerRect.right + FLOATING_GAP;
  const left = rightSideLeft + width <= window.innerWidth - FLOATING_MARGIN
    ? rightSideLeft
    : triggerRect.left - width - FLOATING_GAP;
  return {
    top: clamp(triggerRect.top, FLOATING_MARGIN, window.innerHeight - height - FLOATING_MARGIN),
    left: clamp(left, FLOATING_MARGIN, window.innerWidth - width - FLOATING_MARGIN)
  };
}

export function useFloatingMenu() {
  const [openId, setOpenId] = useState<string | null>(null);
  const [position, setPosition] = useState<FloatingPosition | null>(null);

  function open(id: string, triggerRect: DOMRect, width: number, height: number) {
    setOpenId(id);
    setPosition(positionFloatingLayer(triggerRect, width, height));
  }

  function close() {
    setOpenId(null);
    setPosition(null);
  }

  return {
    openId,
    position,
    open,
    close,
    setOpenId,
    setPosition
  };
}
